export const isJsonResponse = response => {
    const contentType = response.headers.get('content-type')
    return contentType && (contentType.includes('application/json') || contentType.includes('application/hal+json'))
}

export const handleResponse = response => {
    if (response.ok) {
        if (isJsonResponse(response)) {
            return response.json()
        } else {
            return response.text()
        }
    } else {
        const error = new Error(formatErrorMessage(response))
        error.response = response
        throw error
    }
}

export const handleError = (dispatch, errAction) => err => {
    dispatch(errAction(err))
}

export const formatErrorMessage = res => `[${res.status}]: ${res.statusText} (${res.url})`

export const errorActions = {}



// WEBPACK FOOTER //
// ./modules/api/apiUtils.js